export default () => {
  const getNepalTime = (date = null) => {
    if (!date) date = new Date();
    return new Date(
      (typeof date === "string" ? new Date(date) : date).toLocaleString(
        "en-US",
        { timeZone: "Asia/Kathmandu" }
      )
    );
  };

  const marketTime = {
    start: getNepalTime().setHours(11, 0, 0, 0),
    end: getNepalTime().setHours(15, 0, 0, 0),
    fridayEnd: getNepalTime().setHours(13, 0, 0, 0),
  };

  return {
    getNepalTime,
    marketTime,
  };
};
